import jsonPath from "JSONPath";
export function mapping(params) {
  return {
    data: [
      "$.data.",
      {
        type: "product",
        gearType: "products",
        showLast: "$.showLast",
        scBrandName: "$.scBrandName",
        scId: "$.scId",
        cardContent: {
          spuId: "$.spuId",
          productName: "$.productName",
          productBrand: "$.brandName",
          scProductName: "$.scProductName",
          categories: "$.categories",
          currency: "$.currency",
          minPrice: "$.minPrice",
          backgroundImage: "$.image",
          link: {
            name: "Product Page",
            url: `${params.productLink}/{$.spuId}--{$.scBrandName}--{$.scProductName}`
          },
          _arrayItemWithCondition: "$.attributeImages[?(@.label=='color')].value",
          _attributes: "$.attributeImages"
        },
        cardSize: "small", //???
        cardAspect: "portrait", //???
        cardGridArea: "a" //???
      }
    ]
  };
}
